const path = "/v2/organization/self/image";
/**
 *
 * @param {import("axios").AxiosInstance} repository
 */
export default function actions(repository) {
  return {
    /**
     * Type is not implemented server side.
     * @param {String} param0.type Type of images to fetch. organization, personal, global
     * @returns {Array}
     */
    async get({ type, offset } = { offset: 0 }) {
      return repository
        .get(`${path}`, {
          params: {
            offset: offset
          }
        })
        .then(data => {
          let images = data.data.object;
          return Promise.resolve(images);
        });
    },
    /**
     *
     * @param {*} param0.images
     */
    async upload({ images, type } = {}) {
      let formData = new FormData();
      for (var i = 0; i < images.length; i++) {
        let file = images[i];
        formData.append("images", file);
      }
      return repository
        .post(`${path}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(_ => {
          return Promise.resolve();
        });
    }
  };
}
